import NavbarItem from "./NavbarItem";
import logo from "../../loghi/logo.svg";
import { Link } from "react-router-dom";

export default function NavbarLeft(props) {
  return (
    <div className="navbar-left">
      <Link to={props.user ? '/mystores' : "/"}>
        <img className="logo" src={logo} alt="logo" />
      </Link>
      <ul>
        {props.links.map((section, i) => {
          return (
            <NavbarItem
              route={section.target}
              content={section.label}
              key={i}
              style={section.button}
            />
          );
        })}
      </ul>
    </div>
  );
}
